import '../services.css';

const MobileDevelopment = () => {
    return (
        <div className="cover w-100">
            {/* Hero Section */}
            <div className="service-hero-section text-white py-5 text-center bg-primary">
                <h1 className="display-4 fw-bold mb-3">Mobile Application Development</h1>

            </div>

            {/* Web Development Section */}
            <div className="container py-5">
                <div className="row align-items-center">
                    {/* Left - Text */}
                    <div className="col-md-8 mb-4 mb-md-0">
                       <h2 className="h3 fw-semibold mb-4">Mobile Development</h2>
                        <p className="text-justify">
                            Mobile app development comes in a variety of shapes and sizes. Your app may necessitate native application development in iOS and/or Android; this is not a problem; we've built many native apps. We create mobile apps for a variety of industries, including IoT (Internet of Things), finance, healthcare, on-demand, travel, and eCommerce
                        </p>
                        <p className="text-justify">
                          We create innovative custom mobile applications with the goal of providing the best User Experience possible. We work closely with you to understand your company's operations, short- and long-term goals, customers, and culture. The end result is a customised solution that exceeds the expectations of your end users.  
                        </p>
                    </div>

                    {/* Right - Image */}
                    <div className="image-area col-md-4 text-center text-md-end h-100">
                        <img
                            src="assets\images\service\mobile.jpg"
                            alt="Mobile Development"
                            className="img-fluid rounded shadow"
                            style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
                        />
                    </div>
                </div>
            </div>

            {/* Android/iOS Application Development */}
            <div className="container py-2">
                {/* Unique Web Design */}
                <div className="mb-5">
                    <h3 className="h4 fw-semibold mb-3">Android/iOS Application Development</h3>
                    <p className="text-justify">
                        Our skilled Android app developers create the best apps for the world's largest app store. We develop Android apps that are well-known.
                    </p>
                    <p className="text-justify">
                        Our iPhone app developers create high-quality iOS apps for tech enthusiasts. We create interactive apps that pique the user's interest.
                    </p>
                </div>

                {/* Progressive Web Applications */}
                <div className="mb-5">
                    <h3 className="h4 fw-semibold mb-3">Progressive Web Applications</h3>
                    <p className="text-justify">
                        By avoiding app store delivery and app installation, PWAs provide an alternative to traditional mobile app development. PWAs are web applications which use browser capabilities to provide an 'app-like' user experience, such as working offline, running a background process, and adding a link to the device home screen. We have worked on frameworks such as Polymer js and have been a part of a core development team for a major travel company.
                    </p>
                </div>

            </div>
        </div>
    );
};

export default MobileDevelopment;
